 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		113: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_uz","52":"lang_vi","53":"lang_zh_cn","54":"lang_zh_tw","55":"locale_ak","56":"locale_ar","57":"locale_be","58":"locale_bg","59":"locale_bs","60":"locale_ca","61":"locale_cs","62":"locale_da","63":"locale_de","64":"locale_el","65":"locale_en","66":"locale_es","67":"locale_et","68":"locale_fi","69":"locale_fil","70":"locale_fr","71":"locale_he","72":"locale_hi","73":"locale_hr","74":"locale_hu","75":"locale_id","76":"locale_is","77":"locale_it","78":"locale_ja","79":"locale_ka","80":"locale_kk","81":"locale_ko","82":"locale_ky","83":"locale_lt","84":"locale_lv","85":"locale_nl","86":"locale_pa","87":"locale_pl","88":"locale_pt","89":"locale_ro","90":"locale_ru","91":"locale_sk","92":"locale_sl","93":"locale_sq","94":"locale_sr","95":"locale_sr_cyrl_me","96":"locale_sv","97":"locale_sw","98":"locale_th","99":"locale_tr","100":"locale_uk","101":"locale_ur","102":"locale_uz","103":"locale_vi","104":"locale_zh","105":"loclae_af","106":"polyfills","108":"vendors~css-vars-ponyfill","109":"vendors~dompurify","110":"vendors~marked","111":"vendors~polyfills"}[chunkId]||chunkId) + "." + {"0":"3dd231b67f4347a36f75","2":"a6ca7893df988be5cf83","3":"89ececab86f65e7af3f2","4":"88807b905e24fbd7e073","5":"bfa20408ab24e5073d26","6":"60e7b29b2fba8eb801f7","7":"a8dc8fe2990959b294d3","8":"c26860744d6deff19b36","9":"c76d6a652dcf1f5e13ba","10":"165aa7cda773aceea893","11":"b111ff47d17653e7d675","12":"c54cea31b8437896d9ea","13":"e510a290dfd073a6633e","14":"986b030bcfd50ae70204","15":"f652093e7a94c98295bd","16":"ae8f29a164f2567bea91","17":"351f86fb96ee24cbd844","18":"278a8c6df760748f5b48","19":"fb000c22d1f946838f2c","20":"14b79b9947682bae0146","21":"272daed5be6c0fe55642","22":"32873513c249225950e1","23":"48cbc0f2f128977ebc6d","24":"f655134a8f767f44eb8b","25":"b2576840f3094f1a6363","26":"9ba2f348327936a8d3dc","27":"49c5b337050c654937a0","28":"5e67fca4dc459b138c13","29":"ac44cae59ddf293a0319","30":"8dc16df9fac7be50ce93","31":"5312528fe64f5bb8d9aa","32":"fa3ea7b406258eaf8cd6","33":"8451dca7565c82bde02b","34":"01573f5f4cccd9de3da6","35":"0a428fbd5d268c8e3698","36":"19b37a6af700a9e03a98","37":"9ee5792715f1910ceef7","38":"605e5dd4b3d135845063","39":"58c6417b768cd59676cd","40":"3cdf0710f592287b232f","41":"ec5365282b22cd8d7be5","42":"7b990e8496d13d12b61c","43":"625d9173edc2b1703371","44":"6b47fde632a8a472ca31","45":"f2e97a8dd8dca5b23ea2","46":"5a665aea26edea3a62c5","47":"0b97cbef30b7ce700d69","48":"3921056ae032e72c5fa5","49":"c71fa5cb081744018e32","50":"adfa9cbbb27210076da6","51":"1c61ea92b2b11a6ed223","52":"55eccc86f0fd42e22f14","53":"e906a853f0ca88ecb786","54":"bc0ba3dbe638a62d61f1","55":"83d203de1b9763c708a2","56":"233803678d999b9c40ed","57":"a9b64685e140ab34ac30","58":"89b767aee3832937b011","59":"7e9dbaef42ffeb981e3c","60":"90838483e1c5cf8171c6","61":"c8a0f7ebf7f47f5506bb","62":"adafac4a5dd51404fa1a","63":"65ba223ed18b6f608524","64":"d23146b45b1552100520","65":"b93f9b6169bb54127c4c","66":"0c7c81a2a7e8ccd5b32e","67":"96b71d023605ce11808a","68":"6937b3d344f0a4193182","69":"99619070063e05f262fc","70":"a900f7a89348a58e8414","71":"92c2c6a561b548bf632a","72":"a4ad3b8666a59a0e7fcd","73":"42c02172b6ac530ec44a","74":"de43bdff248a7bec7e78","75":"516bf45f3d7f44d9cc05","76":"5006a47f6a95baa8a692","77":"1f7897b99dc66fb35f20","78":"fec3bf27339d1f2c60b0","79":"95541ec540e080fad684","80":"851d07208b9ff6e28783","81":"9c414b33e401800d8643","82":"a066e80e1405dd6a704e","83":"4884afd7d4fe0e31ecb9","84":"e58399fc4e24d2719620","85":"f9156821c326bf3ff81c","86":"9d7da121a5a0974cfdfe","87":"f7629d4eb4780a49bbc0","88":"f5dfdaeba68ddf295635","89":"f6e4de6203b3f4c76540","90":"391af9f3a22fcde06217","91":"ab47903bcd4f063eb331","92":"0f10466c182b5c599f95","93":"5e6e6be149d6a46e4bf7","94":"b31f8cde412c5616168d","95":"08fc3a18b8b763a48cc6","96":"30fd211b2fa7c05505cb","97":"2888fd226f532939db10","98":"3f72f551ceeff6d4e2ae","99":"f4f8215309ff7538d390","100":"67127d5281c131836c4c","101":"afb2ac275f5094195754","102":"c8762dd4ea14f169fa47","103":"6fa9288257ccf8a53fb2","104":"a7fcedc76a5c3a9ef3ee","105":"595babeecf2cb8560a22","106":"538292766c4d304111d2","108":"a4763fe8671dd889a9bf","109":"bed3831a49b3b3788ab1","110":"636a7e75c6c2853769f6","111":"25f27c9bcda79084c367"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/release-v0.1.175/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 83);
